//project-map-work.js

import React, { useState, useRef, useEffect } from "react";

import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { motion } from "framer-motion";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "../App.css"; 

/* أيقونة مخصصة */
const customIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/854/854878.png",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

/* بيانات المدن */
const cities = [
  { id: 1, name: "الرياض", lat: 24.7136, lng: 46.6753, projects: 120 },
  { id: 2, name: "جدة", lat: 21.4858, lng: 39.1925, projects: 80 },
  { id: 3, name: "مكة المكرمة", lat: 21.3891, lng: 39.8579, projects: 50 },
  { id: 4, name: "المدينة المنورة", lat: 24.5247, lng: 39.5692, projects: 40 },
  { id: 5, name: "الدمام", lat: 26.3927, lng: 49.9777, projects: 35 },
  { id: 6, name: "الخبر", lat: 26.2172, lng: 50.1971, projects: 25 },
  { id: 7, name: "أبها", lat: 18.2465, lng: 42.5117, projects: 20 },
  { id: 8, name: "تبوك", lat: 28.3835, lng: 36.5662, projects: 15 },
  { id: 9, name: "الطائف", lat: 21.2703, lng: 40.4158, projects: 15 },
  { id: 10, name: "القصيم", lat: 26.3540, lng: 43.9818, projects: 15 },
];


function MapController({ selectedCity, markersRef }) {
  const map = useMap();
  useEffect(() => {
    if (selectedCity) {
      const { lat, lng, id } = selectedCity;
      map.flyTo([lat, lng], 9, { duration: 1.2 });
      const marker = markersRef.current[id];
      if (marker) {
        try {
          if (typeof marker.openPopup === "function") {
            marker.openPopup();
          } else if (marker.leafletElement && typeof marker.leafletElement.openPopup === "function") {
            marker.leafletElement.openPopup();
          }
        } catch (err) {
          // console.warn("Could not open popup programmatically", err);
        }
      }
    }
  }, [selectedCity, map, markersRef]);

  return null;
}

function ProjectMapWork() { 
  const [selectedCity, setSelectedCity] = useState(null);
  const markersRef = useRef({});

  const totalProjects = cities.reduce((s, c) => s + c.projects, 0);

  return (
    // <<< --- (!!!) --- التعديل هنا --- (!!!) --- >>>
    // 1. إضافة الحاوية الجديدة
    <div className="map-layout-container">
      
      {/* 2. حاوية الكروت (العمود اليمين) */}
      <div className="cards-container">
        {cities.map((city) => (
          <motion.div
            key={city.id}
            className="city-card"
            onClick={() => setSelectedCity(city)}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: city.id * 0.03 }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setSelectedCity(city);
            }}
            aria-label={`عرض مشاريع ${city.name}`}
          >
            <h2>{city.name}</h2>
            <p>عدد المشاريع: {city.projects}</p>
          </motion.div>
        ))}
      </div>

      {/* 3. حاوية الخريطة (العمود الشمال) */}
      <div className="map-and-total-container">
        <div className="total-projects">إجمالي المشاريع: {totalProjects}</div>
        <div className="map-container" aria-hidden={false}>
          <MapContainer
            center={[23.8859, 45.0792]}
            zoom={5}
            scrollWheelZoom={true}
            style={{ height: "100%", width: "100%" }} // <-- تعديل بسيط
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; OpenStreetMap contributors"
            />

            {cities.map((city) => (
              <Marker
                key={city.id}
                position={[city.lat, city.lng]}
                icon={customIcon}
                ref={(ref) => {
                  if (ref) markersRef.current[city.id] = ref;
                }}
              >
                <Popup>
                  <b>{city.name}</b> <br />
                  عدد المشاريع: {city.projects}
                </Popup>
              </Marker>
            ))}

            <MapController selectedCity={selectedCity} markersRef={markersRef} />
          </MapContainer>
        </div>
      </div>

    </div>
  );
}

export default ProjectMapWork;

